'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactackleIcons = require('reactackle-icons');

var _reactackleCore = require('reactackle-core');

var _IconHome = require('../BreadcrumbsItem/styles/IconHome');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = {
  item: {
    maxWidth: null,
    colorScheme: {
      light: {
        default: {
          color: _reactackleCore.bodyFontColorAlt,
          opacity: 1,
          hover: {
            color: null,
            // will take defaults if null
            opacity: null // will take defaults if null

          },
          focus: {
            color: null,
            // will take hover if null
            opacity: null // will take hover if null

          }
        },
        active: {
          color: _reactackleCore.bodyFontColorAlt,
          opacity: 0.7,
          hover: {
            color: null,
            // will take defaults if null
            opacity: null // will take defaults if null

          },
          focus: {
            color: null,
            // will take hover if null
            opacity: null // will take hover if null

          }
        }
      },
      dark: {
        default: {
          color: _reactackleCore.bodyFontColor,
          opacity: 1,
          hover: {
            color: null,
            // will take defaults if null
            opacity: null // will take defaults if null

          },
          focus: {
            color: null,
            // will take hover if null
            opacity: null // will take hover if null

          }
        },
        active: {
          color: _reactackleCore.bodyFontColor,
          opacity: 0.7,
          hover: {
            color: null,
            // will take defaults if null
            opacity: null // will take defaults if null

          },
          focus: {
            color: null,
            // will take hover if null
            opacity: null // will take hover if null

          }
        }
      }
    },
    textBox: {
      paddingY: (0, _reactackleCore.bmodule)(1),
      paddingX: 0
    },
    title: {
      fontSize: _reactackleCore.fontSizeBody,
      lineHeight: 1.5,
      fontWeight: _reactackleCore.fontWeightSemibold,
      textTransform: 'none',
      colorScheme: {
        dark: {
          color: 'currentColor'
        },
        light: {
          color: 'currentColor'
        }
      },
      state: {
        default: {
          textDecoration: 'none',
          hover: {
            textDecoration: 'underline' // will take defaults if null

          },
          focus: {
            textDecoration: null // will take hover if null

          }
        },
        active: {
          textDecoration: 'none',
          hover: {
            textDecoration: null // will take defaults if null

          },
          focus: {
            textDecoration: null // will take hover if null

          }
        }
      }
    },
    subtitle: {
      marginTop: 0,
      fontSize: _reactackleCore.fontSizeSmall,
      lineHeight: 1.5,
      fontWeight: _reactackleCore.fontWeightNormal,
      textTransform: 'none',
      colorScheme: {
        dark: {
          color: 'currentColor'
        },
        light: {
          color: 'currentColor'
        }
      }
    },
    icon: {
      height: 24,
      width: null,
      // will take height as a default
      imgHeight: 20,
      // will take height as a default
      imgWidth: null,
      // will take width as a default
      opacity: 0.5,
      marginLeft: (0, _reactackleCore.bmodule)(0.5),
      marginY: 0,
      alignSelf: 'center',
      // One of 'top', 'center', 'bottom'
      colorScheme: {
        dark: {
          color: 'currentColor'
        },
        light: {
          color: 'currentColor'
        }
      }
    },
    separator: {
      marginY: 0,
      marginX: (0, _reactackleCore.bmodule)(1),
      height: 24,
      width: null,
      // will take height as a default
      imgHeight: 20,
      // will take height as a default
      imgWidth: null,
      // will take width as a default
      fontSize: _reactackleCore.fontSizeBody,
      opacity: 0.5,
      iconSource: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, {
        size: 'custom',
        color: 'currentColor'
      }),
      colorScheme: {
        dark: {
          color: 'currentColor'
        },
        light: {
          color: 'currentColor'
        }
      }
    },
    iconHome: {
      source: _react2.default.createElement(_IconHome.IconHome, {
        size: 'custom',
        color: 'currentColor'
      }),
      marginY: 8,
      marginRight: (0, _reactackleCore.bmodule)(0.5),
      alignSelf: 'top',
      // One of 'top', 'center', 'bottom'
      height: 16,
      width: null,
      // will take height as a default
      imgHeight: null,
      // will take height as a default
      imgWidth: null,
      // will take width as a default
      opacity: 0.5,
      colorScheme: {
        dark: {
          color: 'currentColor'
        },
        light: {
          color: 'currentColor'
        }
      }
    },
    iconMenuSource: _react2.default.createElement(_reactackleIcons.IconArrowDropDown, {
      size: 'custom',
      color: 'currentColor'
    })
  },
  navigation: {
    margin: (0, _reactackleCore.bmodule)(1)
  }
};